import { BY_RESUMO_CAMPANHA, BY_USUARIO_CAMPANHA, CampanhaProdutosActionTypes, CampanhaProdutosState } from "../../../types/produto/produto";

const INITIAL_STATE: CampanhaProdutosState = {
  byUsuarioCampanha: [],
  byResumoCampanha: {} as any,
};

export function CampanhaProdutosReducer(
  state = INITIAL_STATE,
  action: CampanhaProdutosActionTypes
): CampanhaProdutosState {
  switch (action.type) {
    case BY_USUARIO_CAMPANHA:
      return { ...state, byUsuarioCampanha: action.payload };
    case BY_RESUMO_CAMPANHA:
      return { ...state, byResumoCampanha: action.payload };
    default:
      return state;
  }
}